// extracted by mini-css-extract-plugin
export default {"reviewingDot":"reviewingDot--ByvoZ"};